import { SHAREURL } from '@/data/config'
function debounce (fn, time) {
  let timer = null
  return function () {
    clearTimeout(timer)
    timer = setTimeout(fn, time)
  }
}

function objToFormData (obj = {}) {
  const fd = new FormData()
  Object.keys(obj).forEach(item => {
    fd.append(item, obj[item])
  })
  return fd
}

function getShareUrl (projectno) {
  return `${SHAREURL}?teamid=${projectno}`
}

function getpostKey (url, data) {
  // 判断data是否是formdata对象，如果是得单独遍历属性
  url = encodeURIComponent(url)
  const key = data instanceof FormData ? data.entries().reduce((src, item) => {
    return src + JSON.stringify(item)
  }, url) : url + JSON.stringify(data)
  return key
}

function upkeyboard () {
  setTimeout(() => {
    const scrollHeight =
      document.documentElement.scrollTop || document.body.scrollTop || 0
    window.scrollTo(0, Math.max(scrollHeight - 1, 0))
  }, 100)
}

export {
  debounce,
  objToFormData,
  getShareUrl,
  getpostKey,
  upkeyboard
}
